<template>
  <div>
    <h1>Pythonx Pro User's</h1>
    <!-- ================ MODAL ADD ========================-->
    <div class="container">
      <!-- Modal -->
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Add Pythonx Pro Users</h4>
            </div>
            <div class="modal-body">
              <!-- ============ modal form ========= -->
              <form class="customWidthhundred">
                <table class="customWidthhundredTable">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>#</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <label for="promocode">Promocode:</label>
                      </td>
                      <td>
                        <input type="text" v-model="promocode" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="addQuerySel">Code Type:</label>
                      </td>
                      <td>
                        <select v-model="addQuerySel" class="customColorSelect">
                          <option value="ONETIME">ONETIME</option>
                          <option value="BULK">BULK</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="comments">Email:</label>
                      </td>
                      <td>
                        <input type="email" v-model="email" />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <button
                          type="submit"
                          class="btn btn-default"
                          data-dismiss="modal"
                          @click="handleSubmit"
                        >SUBMIT</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
              <!-- ============ modal form ends========= -->
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
          <!-- Modal content ends-->
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-float-right"
      data-toggle="modal"
      data-target="#myModal"
    >Add Users</button>
    <triangle-loader v-if="loader" />
    <mdb-datatable
      v-if="!loader && fetchCretingCourseData && fetchCretingCourseData.columns.length && fetchCretingCourseData.rows.length"
      class="style pading"
      :data="fetchCretingCourseData"
      striped
      bordered
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mdbDatatable } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
Vue.use(VueLoaders);

export default {
  name: "PythonxProUser",
  components: {
    mdbDatatable,
  },
  created() {
    this.fetchPythonxProUserList_();
  },
  watch: {
    fetchCretingCourseData(value) {
      this.data.rows = value.rows;
    }
  },
  computed: {
    ...mapGetters({
      showData: "showData",
      loader: "showLoader"
    }),
    fetchCretingCourseData: {
      get: function() {
        let courseData = this.data
        courseData.rows = [];
        courseData.rows = this.showData.pythonxProUserList;
        courseData.rows = courseData.rows.map(item => {
          let mItem = {}
          mItem.promo_code = item.promo_code
          mItem.code_type = item.code_type
          mItem.user_id = item.user_id
          mItem.email_id = item.email_id
          mItem.created_date = item.created_date
          return mItem;
        });
        return courseData;
      }
    },
  },
  methods: {
    ...mapActions([
      "addPythonxProCourseUser",
      "fetchPythonxProUserList"
    ]),
    handleSubmit: async function() {
      await this.addPythonxProCourseUser({
        promo_code: this.promocode,
        code_type: this.addQuerySel,
        email: this.email
      }).then(res => {
        if (res == "200" || res == "301") {
          this.fetchPythonxProUserList_();
        }
      });
      this.promocode = "";
      this.email = "";
      this.addQuerySel = "ONETIME";
    },
    fetchPythonxProUserList_: async function() {
      await this.fetchPythonxProUserList();
    },
  },
  data() {
    return {
      addQuerySel: "ONETIME",
      promocode: "",
      code_type: "",
      email: "",
      data: {
        loading: false,
        columns: [
          {
            label: "PromoCode",
            field: "promo_code",
            sort: "asc"
          },
          {
            label: "Code_Type",
            field: "code_type",
            sort: "asc"
          },
          {
            label: "User Id",
            field: "user_id",
            sort: "asc"
          },
          {
            label: "Email Id",
            field: "email_id",
            sort: "asc"
          },
          {
            label: "Created",
            field: "created_date",
            sort: "asc"
          },
        ],
        rows: []
      }
    };
  }
};
</script>

<style>
.style{
  font-size: 15px;
}
.sidebar + div .dataTables_wrapper.style .row div div div select {
  padding-top: 0.25rem !important;
  padding-bottom: 0.45rem !important;
  height: calc(2.2125rem + 2px) !important;
  font-size: 12px;
}
.sidebar + div .dataTables_wrapper.style .row {
  margin-top: 15px;
  margin-bottom: 15px;
}
.sidebar + div .dataTables_wrapper.style .row div div div label {
  margin-right: 10px;
}
.sidebar + div .dataTables_wrapper.style .row div div label {
  margin-right: 15px;
}
.sidebar + div .dataTables_wrapper.style .row div div input {
  font-size: 15px;
}
.custom-select {
  font-size: 15px;
  padding: 7px 10px;
}
.table-fill {
  background: white;
  border-radius: 3px;
  border-collapse: collapse;
  height: 320px;
  margin: auto;
  max-width: 600px;
  padding: 5px;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  animation: float 5s infinite;
}
.customWidthhundredTable {
  width: 100%;
}
th {
  color: #d5dde5;
  background: #1b1e24;
  border-bottom: 4px solid #9ea7af;
  border-right: 1px solid #343a45;
  font-size: 23px;
  font-weight: 100;
  padding: 24px;
  text-align: left;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}
th:first-child {
  border-top-left-radius: 3px;
}
th:last-child {
  border-top-right-radius: 3px;
  border-right: none;
}
tr {
  border-top: 1px solid #c1c3d1;
  border-bottom: 1px solid #c1c3d1;
  color: #666b85;
  font-size: 16px;
  font-weight: normal;
  text-shadow: 0 1px 1px rgba(256, 256, 256, 0.1);
}
tr:hover td {
  background: #4e5066;
  color: #9ea7af;
  border-top: 1px solid #22262e;
}
tr:first-child {
  border-top: none;
}
tr:last-child {
  border-bottom: none;
}
tr:nth-child(odd) td {
  background: #ebebeb;
}
tr:nth-child(odd):hover td {
  background: #4e5066;
}
tr:last-child td:first-child {
  border-bottom-left-radius: 3px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 3px;
}
td {
  background: #ffffff;
  padding: 20px;
  text-align: left;
  vertical-align: middle;
  font-weight: 300;
  font-size: 18px;
  text-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #c1c3d1;
}
td:last-child {
  border-right: 0px;
}
th.text-left {
  text-align: left;
}
th.text-center {
  text-align: center;
}
th.text-right {
  text-align: right;
}
td.text-left {
  text-align: left;
}
td.text-center {
  text-align: center;
}
td.text-right {
  text-align: right;
}
.pading th{
  padding:8px 3px !important;
}
</style>